import React from 'react'
import { ScreeningQuestionAnswer } from 'types/campaign/applications'

const ScreeningQuestionAnswers: React.FC<{ answers: ScreeningQuestionAnswer[] }> = ({ answers }) => {
    const formatAnswer = (answer: ScreeningQuestionAnswer['answer']) => {
        if (typeof answer === 'boolean') return answer ? 'Yes' : 'No'
        return answer
    }

    return (
        <div className="detail-card border-1 screening-question-answers">
            <div className="detail-card-header">Screening Questions</div>

            <div className="detail-card-body screening-question-answers__body">
                <div className="screening-question-answers__list">
                    {answers.map((a) => (
                        <div className="screening-question-answers__row" key={`${a.question}-${String(a.answer)}`}>
                            <span className="screening-question-answers__bullet" aria-hidden="true" />
                            <div className="screening-question-answers__text">
                                <div className="screening-question-answers__question">{a.question}</div>
                                <div className="screening-question-answers__answer">{formatAnswer(a.answer)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ScreeningQuestionAnswers